var map = {
	"./alumna-certificada-fundacion-nican.png": 1479,
	"./alumnos-graduados-certificacion-sep.png": 5822,
	"./egresado-con-diploma-profesional.png": 8474,
	"./graduacion-certificaciones-fundacion-nican.png": 1082,
	"./historias-de-exito-fundacion-nican.png": 7547,
	"./personas-capacitadas-para-el-empleo.png": 3543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9098;